
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Footer extends Vue {
  lang = localStorage.getItem("lang") || "el";
  termsAndConditionsURL = "";
  privacyPolicyURL = "";
  corporateInformationURL = "";
  appVersion = "";
  gitCommit = "";

  get versionLabel(): string {
    if (!this.appVersion) return "";
    if (this.gitCommit && this.gitCommit !== "unknown") {
      return `${this.appVersion} @ ${this.gitCommit}`;
    }
    return this.appVersion;
  }

  async mounted() {
    this.termsAndConditionsURL =
      this.lang === "el"
        ? "https://domx.io/el/policy/oroi-xrhshs-domx-for-business/"
        : "https://domx.io/policy/terms-conditions-domx-for-business/";
    this.privacyPolicyURL =
      this.lang === "el"
        ? "https://domx.io/el/policy/politiki-aporritou/"
        : "https://domx.io/policy/privacy-policy/";
    this.corporateInformationURL =
      this.lang === "el"
        ? "https://domx.io/el/contact-el/"
        : "https://domx.io/contact/";

    try {
      const response = await fetch("/version.json");
      const versionData = await response.json();
      this.appVersion =
        versionData.version || process.env.VUE_APP_VERSION || "0.1.0";
      this.gitCommit = versionData.gitCommit || "";
    } catch {
      this.appVersion = process.env.VUE_APP_VERSION || "0.1.0";
      this.gitCommit = "";
    }
  }
}
